var exports = {
  "v": "i3fdetails-b0FoL",
};

module.exports = exports;
